/**
 * True when `host` is a host the URL parser accepts as-is. Custom domains
 * are stored from free-form user input (CustomDomainFeature) and read back
 * out of site config, so values like "my domain.com" can reach render —
 * those must be skipped rather than allowed to throw in `new URL(...)` and
 * unmount the page. Compares `url.host` (not `hostname`) so dev hosts with
 * a port (e.g. `mysite.localhost:3001`) validate too.
 */
export const isValidHostname = (host: string): boolean => {
  if (!host) return false;
  try {
    return new URL(`https://${host}`).host === host.toLowerCase();
  } catch {
    return false;
  }
};

export const buildEncodedUrl = (rawUrl: string): string => {
  const url = new URL(rawUrl);
  url.searchParams.set('utm_source', 'qr_code');
  url.searchParams.set('utm_medium', 'qr');
  return url.toString();
};

export const slugifyForFilename = (rawUrl: string): string => {
  let host = rawUrl;
  try {
    host = new URL(rawUrl).hostname;
  } catch {
    // Already a hostname-ish string
  }
  return host
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '');
};
